import type { ReactNode } from "react";
import { Modal } from "./Modal";

interface Props {
  open: boolean;
  title: string;
  body?: string;
  confirmLabel?: string;
  confirmIcon?: ReactNode;
  cancelLabel?: string;
  onConfirm: () => void;
  onCancel: () => void;
  "data-testid"?: string;
}

export function ConfirmModal({
  open,
  title,
  body,
  confirmLabel = "Bekreft",
  confirmIcon,
  cancelLabel = "Avbryt",
  onConfirm,
  onCancel,
  "data-testid": testId,
}: Props) {
  return (
    <Modal open={open} onClose={onCancel} data-testid={testId} size="sm">
      <h2>{title}</h2>
      {body ? <p className="modal-body">{body}</p> : null}
      <div className="modal-actions">
        <button
          type="button"
          className="btn ghost"
          onClick={onCancel}
          data-testid="confirm-cancel-button"
        >
          {cancelLabel}
        </button>
        <button
          type="button"
          className={`btn danger${confirmIcon ? " icon-btn" : ""}`}
          onClick={onConfirm}
          data-testid="confirm-confirm-button"
        >
          {confirmIcon}
          {confirmLabel}
        </button>
      </div>
    </Modal>
  );
}
